import Header from "./Components/Header";
import Footer from "./Components/Footer";
import NavBar from "./Components/NavBar";
import "./index.css";
function App() {
  return (
    <div div className="bg-black min-h-screen w-full">
      <NavBar />    
      <Header />
      <Footer />
    </div>
  );
}
export default App;
